import { Box, Button, Text } from 'grommet'
import { Close } from 'grommet-icons';
import React from 'react'
import { useNavigate } from 'react-router-dom';

const SectionTitle = (props:any) => {

  let navigate = useNavigate();

  const gotoMain = ()=>{
    navigate("/archive")
  }

  return (
    <>
      <Box alignSelf="end">
        <Button 
          hoverIndicator 
          onClick={()=>gotoMain()}
          icon={<Close color="white" size="15px" />} />
      </Box>
      <Box width="full" align="center" justify="center">
        <Text size="20px" weight="bold" color="white">
          {props.title}
        </Text>
      </Box>
    </>
  );
}

export default SectionTitle;